import React from 'react'

import type { IconProps } from './types'

const SimilacArticle: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M33.455 2.423 6.826 6.407a2.86 2.86 0 0 0-2.403 3.25l5.016 33.516a2.86 2.86 0 0 0 3.249 2.404l26.628-3.985a2.86 2.86 0 0 0 2.403-3.25L36.704 4.827a2.86 2.86 0 0 0-3.25-2.403"
        fill="#3761B3"
      />
      <path
        d="M6.817 8.926 34.2 4.828l5.02 33.55-27.383 4.097z"
        fill="#E6F0FA"
      />
      <path
        d="m21.572 10.758-.944.141a1.38 1.38 0 0 0-1.161 1.57l.035.235a.3.3 0 0 1-.25.339l-.235.035a1.383 1.383 0 0 0-1.161 1.57l.141.946a1.38 1.38 0 0 0 1.57 1.16l.236-.035a.3.3 0 0 1 .338.25l.036.236a1.38 1.38 0 0 0 1.57 1.16l.944-.141a1.38 1.38 0 0 0 1.162-1.57l-.036-.236a.297.297 0 0 1 .25-.339l.236-.035a1.38 1.38 0 0 0 1.162-1.57l-.142-.944a1.383 1.383 0 0 0-1.57-1.16l-.236.035a.3.3 0 0 1-.339-.25l-.035-.236a1.38 1.38 0 0 0-1.57-1.161"
        fill="#012F87"
      />
      <path
        d="m32.495 19.747-15.52 2.322a.534.534 0 1 0 .159 1.057l15.52-2.322a.534.534 0 0 0-.159-1.057m.498 3.839-19.453 2.91a.534.534 0 1 0 .158 1.057l19.453-2.91a.534.534 0 1 0-.158-1.057m-.987 4.06-17.968 2.689a.534.534 0 0 0 .158 1.056l17.968-2.688a.534.534 0 1 0-.158-1.057m-1.808 4.183-15.663 2.344a.534.534 0 0 0 .158 1.056l15.664-2.344a.534.534 0 1 0-.159-1.056m3.866-.579-1.38.207a.534.534 0 0 0 .158 1.057l1.38-.207a.534.534 0 0 0-.158-1.057"
        fill="#98B0DF"
      />
    </svg>
  )
}

export default SimilacArticle
